const getAppBasename = (pathname: string): string => pathname.split("/")[1] || "";

interface BrowserPathOptions {
  route: string;
  pathname: string;
}

export const getBrowserPath = ({ route, pathname }: BrowserPathOptions): string => {
  if (!route.startsWith("/")) return route;

  const basename = getAppBasename(pathname);
  return basename ? `/${basename}${route}` : route;
};
